angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAddremove', function (
  $http,
  $log,
  $q,
  language,
  EventManager,
  TeacherDataService,
  $timeout,
  LocaleService,
  api,
  preliveCheck
) {

  return {

    templateUrl: 'template.html',

    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {
      scope.isPrelive = function(){
        return preliveCheck.isPreliveCheck();
      }
      scope.archivedStudents = [];
      scope.showActiveStudents = true;
      scope.sort = {
        order:'ASC',
        by:'first_name',
        prevSortBy:'first_name'
      }
      scope.pdfGeneration = {
        isGeneratePdfModalVisible:false,
        selectedStudent:{},
        showExportDate:false
      }


      scope.showGeneratePDFModal = function(student){
        scope.pdfGeneration.isGeneratePdfModalVisible = true;
        scope.pdfGeneration.selectedStudent = student;
      }

      var getProgressRingForPdf = function(size, score, lock){
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock){
          url += 'teachview-ring-'+size+'-locked.png'
        }
        else{
          var num = score ? Math.min(21 , Math.round(21*score)) : 0;
          if (num === 0){
            url += 'teachview-ring-'+size+'-blank.png'
          }
          else{
            if ( String(num).length === 1){
              num = '0'+num;
            }
            url += 'teachview-ring-'+size+'-fill00'+num+'.png'
          }
        }
        return url;
      }

      var createRingImage = function(imageSource,imageWidth,imageStartPositionX,imageStartPositionY,specialElementHandlers,doc){
        var defer = $q.defer();
        var img = document.createElement('img');//new Image(); // width, height values are optional params 
        img.width = imageWidth;
        img.src = imageSource;
        img.style.display = "inline-block";
        img.setAttribute("style", "display : inline");
        var body = document.createElement("body");
        body.appendChild(img);
        doc.fromHTML( body, imageStartPositionX, imageStartPositionY, {
          'width': 10, // max width of content on PDF
          'elementHandlers': specialElementHandlers
        }, function(bla) {   
          // $log.log(bla);
          defer.resolve();
        });

        return defer.promise;
      }

      scope.downloadStudentProgressPdf = function(student,shouldShowExportDate){
        if(scope.pdfGeneration.generatingPdf){
          return;
        }
        scope.pdfGeneration.generatingPdf =true;
        var name = student.user.info.first_name+" "+student.user.info.last_name;
        var doc = new jsPDF();
        doc.text(20, 20, "Name: "+name);
        doc.text(20, 30, "Class: "+scope.selectedClass.name);
        if(shouldShowExportDate){
          doc.text(20, 40, "Date of Export: "+moment().format('YYYY-MM-DD'));
        }

        var promises = [];
        angular.forEach(scope.modules,function(each,index){
          var stats = student.moduleWorkSummary[each.resource_id].stats;
          var specialElementHandlers = {
            '#editor': function(element, renderer){
              return true;
            },
            '.controls': function(element, renderer){
              return true;
            }
          };
          var starty = 60;
          doc.text(20, starty+10+(index*20), scope.getModuleName(each));
          var startx = 120;
          var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
          var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
          var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
          promises.push(createRingImage(firstProgressRingSrc,"10",startx,starty+2.5+(index*20),specialElementHandlers,doc));
          promises.push(createRingImage(secondProgressRingSrc,"15",startx+10,starty+(index*20),specialElementHandlers,doc));
          promises.push(createRingImage(thirdProgressRingSrc,"10",startx+10+15,starty+2.5+(index*20),specialElementHandlers,doc));
        });

        $q.all(promises).then(function(){
          doc.save(scope.selectedClass.id+"_"+student.user.user_id+'.pdf')
          scope.pdfGeneration ={};
        },function(err){
          scope.pdfGeneration.generatingPdf = false;
        });
      }

      scope.downloadAllStudentProgressPdf = function(students){
        var promises = [];
        var doc = new jsPDF();
        var rowStartX = 10;
        var rowStartY = 20;
        var verticalDiffBetweenItems = 15;
        var pageWidth = doc.internal.pageSize.width-rowStartX;
        var columnWidth = pageWidth/(scope.modules.length+2);
        doc.setFontSize(10);
        doc.text(rowStartX, rowStartY, language.get('11299'));
        doc.text(rowStartX+columnWidth, rowStartY, language.get('11300'));
        angular.forEach(scope.modules,function(each,index){
          var splitTitle = doc.splitTextToSize(scope.getModuleName(each),columnWidth);
          doc.text(rowStartX+(columnWidth*(index+2)),rowStartY, splitTitle);
        });
        doc.setFontSize(9);
        students.forEach(function(student,studentIndex){
          var splitFirstName = doc.splitTextToSize(student.user.info.first_name,columnWidth);
          var splitLastName = doc.splitTextToSize(student.user.info.last_name,columnWidth);
          doc.text(rowStartX, rowStartY+(verticalDiffBetweenItems*(studentIndex+1)), splitFirstName);
          doc.text(rowStartX+columnWidth, rowStartY+(verticalDiffBetweenItems*(studentIndex+1)), splitLastName);

          angular.forEach(scope.modules,function(each,index){
            var stats = student.moduleWorkSummary[each.resource_id].stats;
            var specialElementHandlers = {
              '#editor': function(element, renderer){
                return true;
              },
              '.controls': function(element, renderer){
                return true;
              }
            };

            var starty = 60;
            // doc.text(20, starty+10+(index*20), scope.getModuleName(each));
            var startx = 120;
            var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
            var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
            var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
            promises.push(createRingImage(firstProgressRingSrc,"3",rowStartX+(columnWidth*(index+2)),rowStartY-2+(verticalDiffBetweenItems*(studentIndex+1)),specialElementHandlers,doc));
            promises.push(createRingImage(secondProgressRingSrc,"5",rowStartX+(columnWidth*(index+2))+3,rowStartY-3+(verticalDiffBetweenItems*(studentIndex+1)),specialElementHandlers,doc));
            promises.push(createRingImage(thirdProgressRingSrc,"3",rowStartX+(columnWidth*(index+2))+3+5,rowStartY-2+(verticalDiffBetweenItems*(studentIndex+1)),specialElementHandlers,doc));
          });
        });
        $q.all(promises).then(function(){
          doc.save(scope.selectedClass.id+"_all"+'.pdf')
        });
      }

      scope.changeSortOrder = function(by,order){
        
        if(by==='FIRST_NAME'){
          scope.sort.by = 'first_name';
        }
        if(by==='LAST_NAME'){
          scope.sort.by = 'last_name';
        }
        scope.sort.order = (order==='ASC')&&(scope.sort.prevSortBy===scope.sort.by)?'DESC':'ASC';
        scope.sort.prevSortBy = scope.sort.by;
      }

      scope.customOrder = function(){
        var sortOrder = scope.sort.order==="ASC"?'-':'';
        var sortString = (sortOrder||"")+"user.info."+scope.sort.by;
        // $log.log(sortString);

        return sortString;
      }

      scope.getTranslation = function(id){
        return language.get(id);
      }

      scope.showArchivedStudentsTab = function(){
        if(!scope.removeStudentEditMode){
          scope.showActiveStudents=false;
          scope.showArchivedStudents=true;
          exitStudentEditForArchiveMode();
        }
      }

      scope.showActiveStudentsTab = function(){
        if(!scope.unArchiveStudentEditMode)
         {
            scope.showActiveStudents=true;
            scope.showArchivedStudents=false;
            exitStudentEditForArchiveMode();
         }
      }

      var exitStudentEditForArchiveMode = function(){
        scope.removeStudentEditMode = false;
        scope.unArchiveStudentEditMode = false;
        scope.showArchiveStudentConfirmModal = false;
        scope.showUnArchiveStudentConfirmModal = false;
      }

      // var exitStudentEditForUnArchiveMode = function(){
      //   scope.unArchiveStudentEditMode = false;
      //   scope.showUnArchiveStudentConfirmModal = false;
      // }

      var archiveStudent = function(student,isArchived){
        return api.archiveStudent(scope.selectedClass.id,student.user.user_id,isArchived);
      }


      var onConfirmArchiveStudents = function(){
        if(scope.statusChangeStarted){
          return;
        }

        scope.statusChangeStarted = true;
        var selectedStudents = _.filter(scope.students,function(student){
          return student.isSelectedForRemoval;
        });

        var archivePromises = [];
        selectedStudents.forEach(function(student){
          archivePromises.push(archiveStudent(student,true));
        });

        $q.all(archivePromises).then(function(){
          scope.students = _.filter(scope.students,function(student){
            if(student.isSelectedForRemoval){
              scope.archivedStudents.push(student);
            }

            return !student.isSelectedForRemoval;
          });
          scope.statusChangeStarted = false;
          exitStudentEditForArchiveMode();
        });
      }

      var onCancelArchiveStudents = function(){
        if(scope.statusChangeStarted)
        {
          return;
        }

        scope.students.forEach(function(student){
          student.isSelectedForRemoval = false;
        });
        exitStudentEditForArchiveMode();
      }

      var archiveStudents = function(){
        var selectedStudents = _.filter(scope.students,function(student){
          return student.isSelectedForRemoval;
        });

        if(!selectedStudents || selectedStudents.length ===0){
          exitStudentEditForArchiveMode();
        }else{
          scope.showArchiveStudentConfirmModal = true;
          // archiveStudent(selectedStudents[0]);
        }
      }

      var unArchiveStudents = function(){
        var selectedStudents = _.filter(scope.archivedStudents,function(student){
          return student.isSelectedForUnarchive;
        });

        if(!selectedStudents || selectedStudents.length ===0){
          exitStudentEditForArchiveMode();
        }else{
          scope.showUnArchiveStudentConfirmModal = true;
          // archiveStudent(selectedStudents[0]);
        }
      }

      scope.onDoneClicked = function(){
        if(scope.removeStudentEditMode){
          archiveStudents();
        }else if(scope.unArchiveStudentEditMode){
          unArchiveStudents();
        }
      }

      // this
      scope.warning_timer_delay = false;
      $timeout(function(){
        scope.warning_timer_delay = true;
      }, 1000)

      // event manager
      var eventManager = new EventManager('teacherStudentsDashboard', scope);

      scope.load_workspace = function(student, module){
        eventManager.broadcast('dashboard:to:workspace', {student, module})
      }

      // model
      scope.loadingStatus = {
        done: false,
        failed: false
      }
      scope.refresh = function(){
        init(scope.selectedClass, true)
      }
      scope.getModuleName = function(module){
        var name = language.get(module.slug);
        if(!name) {
          name = module.slug;
        }
        return name;
      }

      scope.language = language;

      var init = function(classroom, reset){
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.students = [];
        var trueCondition = true === true;

        $q.all([
          TeacherDataService.getModuleListFlat(classroom.id)
          .then(function(modules){
            scope.modules = modules.filter(function(module){
              return !module.hasSubModules;
            });
            return;
          }),
          TeacherDataService.getClassStats(classroom.id,true)
          .then(function(studentWork){
            scope.students = studentWork;
            // if(preliveCheck.isPreliveCheck()){
              TeacherDataService.getArchivedClassStats(classroom.id,true,null,true)
              .then(function(studentWork){
                scope.archivedStudents = studentWork;
              })
            // }

          }),
        ])
        .then(function(){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
        })
        .catch(function(){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
        })
      }

      var onConfirmUnArchiveStudents = function(){
        if(scope.statusChangeStarted){
          return;
        }

        scope.statusChangeStarted = true;
        var selectedStudents = _.filter(scope.archivedStudents,function(student){
          return student.isSelectedForUnarchive;
        });

        var unArchivePromises = [];
        selectedStudents.forEach(function(student){
          unArchivePromises.push(archiveStudent(student,false));
        });

        $q.all(unArchivePromises).then(function(){
          scope.archivedStudents   = _.filter(scope.archivedStudents,function(student){
            if(student.isSelectedForUnarchive){
              scope.students.push(student);
            }

            return !student.isSelectedForUnarchive;
          });
          scope.statusChangeStarted = false;
          exitStudentEditForArchiveMode();
        });
      }

      var onCancelUnArchiveStudents = function(){
        if(scope.statusChangeStarted)
        {
          return;
        }

        scope.archivedStudents.forEach(function(student){
          student.isSelectedForUnarchive = false;
        });
        exitStudentEditForArchiveMode();
      }

      scope.onConfirmStudentStatusChange = function(){
        if(scope.showArchiveStudentConfirmModal){
          onConfirmArchiveStudents();
        }else if(scope.showUnArchiveStudentConfirmModal){
          onConfirmUnArchiveStudents();
        }
      }

      scope.onCancelStudentStatusChange = function(){
        if(scope.showArchiveStudentConfirmModal){
          onCancelArchiveStudents();
        }else if(scope.showUnArchiveStudentConfirmModal){
          onCancelUnArchiveStudents();
        }
      }

      TeacherDataService.getUserClasses()
      .then(function(classes){
        scope.classes = classes;
        scope.$watch('selectedClass', function(classroom){
          if (classroom){
            init(classroom);
          }
        });
      });

      //custom filter to order teacher view modules, based on cycle
      scope.customModuleFilter = function(module){
        var gr78 = [
          "mtic_gr78_m1",
          "mtic_gr78_m0",
          "mtic_gr78_m2",
          "mtic_gr78_m3",
          "mtic_gr78_c4_m1",
          "mtic_gr78_c4_m6",
        ]
        var c4 = [
          "c4_m1",
          "c4_m2",
          "c4_m3",
          "c4_m4",
          "c4_m5",
          "c4_m6",
        ]
        var c3 = [
          "mtic_c3_m1",
          "mtic_c3_m3",
          "run_like_math_addition",
          "run_like_math_subtraction",
          "run_like_math_multiplication",
          "run_like_math_division",
        ]
        if(gr78.indexOf(module.slug) > -1){
          return gr78.indexOf(module.slug)
        }else if(c3.indexOf(module.slug) > -1){
          return c3.indexOf(module.slug)
        }else if(c4.indexOf(module.slug) > -1){
          return c4.indexOf(module.slug)
        }
      }

      scope.show_info_and_scroll = function(){
        scope.show_add_info = true; scope.warning_timer_delay = true
        $timeout(function(){
          document.getElementById('studentStatsDashboard').scrollTo(0,document.body.scrollHeight);
        },100)
      }

      scope.isLuxUser = function(){
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      }

    }


  }


});
